import { Component, Input, OnInit } from '@angular/core';
import { ElementType } from 'src/app/_objects/element-type';
import { ReportTable } from 'src/app/_objects/report-table';
import { FromToDetail } from 'src/app/_objects/report-template';
import { MousePoint, Notifier, ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';

@Component({
    selector: 'app-report-table',
    templateUrl: './report-table.component.html',
    styleUrls: ['./report-table.component.scss'],
    standalone: false
})
export class ReportTableComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public tableKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportTable: ReportTable;
  public resizeMarkerSize: number;
  public resizing: boolean;
  public isCustomDrawEnable: boolean;

  constructor(public designService: ReportTemplateDesignService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'report-table.component',
      ids: { pageId: this.pageKey, elementId: this.tableKey }
    };
    this.isCustomDrawEnable = this.designService.customElementAdd;
    this.reportTable = this.designService.getTable(this.tableKey);
    const elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey === this.pageKey)[0]
    .elementsDetails.filter((y) => y.location === this.elementLocation)[0]
    .elements;
    // elementNavigator =
    elementNavigator.filter(x => x.elementName === ElementType.Table).length > 0
      ? elementNavigator.filter(x => x.elementName === ElementType.Table)[0].elementData.push({
          id: this.tableKey,
          page: this.pageKey,
          name: this.reportTable.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.Table,
          isVisible: false,
          elementData: [
            {
              id: this.tableKey,
              page: this.pageKey,
              name: this.reportTable.getTitle(),
            },
          ],
        });
  }

  public onClick(event: MouseEvent) {
    if (this.reportTable.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.tableKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  public onDragStart(event: DragEvent) {
    // console.log('ReportImage onDragStart');
    event.dataTransfer.setData('text', this.tableKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportTable.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.MeasurementPoint, fromDetail, dragPoint);
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportImage onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportImage onDrop');
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportTable.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportTable.getLeftPx() + event.offsetX,
      onElementY: this.reportTable.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportTable.getWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportTable.getWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportTable.getHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportTable.getHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    // console.log('reportTable onResizeMarkerDown');
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    this.designService.notifyBeginResize(this.notifier, ElementType.Text, horizontal, vertical, beginPoint);

    event.stopPropagation();
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY });
    }
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

}
